import {Component, Input, OnInit} from '@angular/core';
import {CdkCopyToClipboard} from "@angular/cdk/clipboard";
import {MatIcon} from "@angular/material/icon";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatTooltip} from "@angular/material/tooltip";
import {BulkAction} from "../../../model/bulk/bulkAction";
import {BulkActionDevice} from "../../../model/bulk/bulkActionDevice";
import {BulkActionType} from "../../../model/bulk/bulkActionType";
import {formatTrackingInterval} from "../../../model/bulk/trackingIntervalOption";

const JSON_SPACING = 2;
const SNACKBAR_DURATION_MS = 3000;

@Component({
  selector: 'app-sms-assignment',
  standalone: true,
  imports: [
    CdkCopyToClipboard,
    MatIcon,
    MatTooltip,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef
  ],
  templateUrl: './sms-assignment.component.html',
  styleUrl: './sms-assignment.component.css'
})
export class SmsAssignmentComponent implements OnInit {
  @Input() bulkAction! : BulkAction;

  private snackBar: MatSnackBar;

  private readonly baseColumns = ["hubDeviceName", "hubDeviceId", "imei", "hubDeviceType", "secureInReach"];
  private readonly smsColumns = ["countryCode", "dedicatedSmsNumber", "oldDedicatedSmsNumber"];
  private readonly trackingIntervalColumns = ["movingInterval", "stationaryInterval"];
  private readonly gatewayColumns = [
    "tenant",
    "oldTenant",
    "connectors",
    "oldConnectors",
    "group",
    "oldGroup"
  ];
  private readonly gatewayDeletionColumns = [
    "imei",
    "deletionDeviceName",
    "deletionDeviceType",
    "deletionDisplayName",
    "deletionOemSerial",
    "deletionTenantId"
  ];

  dataSource: MatTableDataSource<BulkActionDevice> | undefined;
  displayedColumns: string[] = [];

  constructor(snackBar: MatSnackBar) {
    this.snackBar = snackBar;
  }

  ngOnInit() {
    let baseColumns: string[];
    let detailColumns: string[];

    if (this.isGatewayDeleteDevices()) {
      baseColumns = this.gatewayDeletionColumns;
      detailColumns = ["deletionResult"];
    } else if (this.isManageGatewayDevices()) {
      baseColumns = ["imei"];
      detailColumns = this.gatewayColumns;
    } else if (this.isUpdateTrackingInterval()) {
      baseColumns = this.baseColumns;
      detailColumns = this.trackingIntervalColumns;
    } else {
      baseColumns = this.baseColumns;
      detailColumns = this.smsColumns;
    }

    this.displayedColumns = [
      ...baseColumns,
      ...detailColumns,
      ...(this.isGatewayDeleteDevices() ? [] : ["errorMessage"]),
      ...(this.isGatewayDeleteDevices() || this.isManageGatewayDevices() ? ["json"] : [])
    ];
    this.dataSource = new MatTableDataSource<BulkActionDevice>(this.bulkAction.bulkActionDevices);
  }

  intervalLabel(seconds: number | undefined): string {
    return formatTrackingInterval(seconds);
  }

  copyGatewayDeviceJsonToClipboard(device: BulkActionDevice) {
    return JSON.stringify(device, null, JSON_SPACING);
  }

  confirmGatewayDeviceJsonCopied() {
    this.snackBar.open('Gateway bulk action row copied to clipboard', undefined, {
      duration: SNACKBAR_DURATION_MS
    });
  }

  private isUpdateTrackingInterval(): boolean {
    return this.bulkAction.bulkActionType === BulkActionType.UPDATE_TRACKING_INTERVAL;
  }

  private isManageGatewayDevices(): boolean {
    return this.bulkAction.bulkActionType === BulkActionType.MANAGE_GATEWAY_DEVICES;
  }

  private isGatewayDeleteDevices(): boolean {
    return this.bulkAction.bulkActionType === BulkActionType.GATEWAY_DELETE_DEVICES;
  }
}
